<template>
  <div class="select_box" v-click-outside="clickOutside">
     <div class="select_box_input " @click.stop="onFocus">
        <input type="text" autocomplete="off" readonly v-model="inputLabel" class="select_box_input_inner">
        <span class="icon_suffix" :class="isDropshow ? 'is_reverse' : ''"></span>
     </div>
     <div class="select_box_dropdown" v-show="isDropshow" >
        <div class="select_box_dropdown_wraper" ref="dropdown">
           <ul class="select_box_dropdow_list">
              <li class="select_box_dropdow_item" v-for="(item,index) in options" :key="item.value" :class="active == index ? 'is_active' : ''" @click="onClick(item,index)">
                 <span>{{item.label}}</span>
              </li>
           </ul>
        </div>
     </div>
  </div>
</template>

<script>
import BScroll from "better-scroll";
export default {
   name:"select-box",
   props:{
      inputValue:{
         type:String
      },
      options:{
         type:Array,
      },
   },
   data() {
      return {
         isDropshow:false,
         active:null,
         inputLabel:"",
      }
   },
   computed:{
      changeVal() {
         let {inputValue,options} = this;
         return {inputValue,options}
      }
   },
   watch:{
      changeVal:{
         handler(dataObj){
            if(dataObj.options.length > 0){
               dataObj.options.map((item,index) => {
                  if(item.value == dataObj.inputValue){
                     this.inputLabel = item.label
                     this.active = index
                  }
               })
            }
            // if(this.scroll){
            //    setTimeout(()=>{
            //       this.initScroll()
            //    },200)
            // }

         },
         immediate:true,
         deep:true
      },
      // options:{
      //    handler(data) {
      //       data.map((item,index) => {
      //          if(item.value == this.inputValue){
      //             this.inputLabel = item.label
      //             this.active = index
      //          }
      //       })
      //    },
      // },
   },
   created() {

   },
    mounted() {
      // this.$nextTick(()=>{
      //    setTimeout(()=>{
      //       this.initScroll()
      //    },200)
      // })
   },
   methods:{
      initScroll() {
         if(!this.$refs.dropdown){
            return;
         }
         this.scroll = new BScroll(this.$refs.dropdown,{
            pullUpLoad: true, // 不触发上拉事件
            scrollbar: false, // 展示滚动条
            pullDownRefresh: true, // 开启下拉刷新事件，需要配合内部配置使用，这里目前没有用到
            scrollX:true,
            scrollY:true,
            bounce:false, // 关闭滚动到边缘时的回弹动作
            click:true, // 开启点击事件
            quadrant:2, // 父元素或者祖先元素旋转的角度为 (45, 135]，quadrant 建议为 2，尤其是 90 度，quadrant 必须为 2
            stopPropagation:true // 内部滑动禁止外补滑动
         })
      },
      // 选择学校
      onClick(item,index) {
         this.active = index;
         this.inputLabel = item.label;
         this.$emit('selectChange',item);
         setTimeout(()=>{
            this.isDropshow = false;
         },18)

      },
      onFocus() {
         // this.isDropshow = true;
         this.isDropshow = !this.isDropshow
          setTimeout(()=>{
            this.initScroll()
         },200)
      },
      // 除下拉框区域之外的点击，受better-scroll影响，目前不生效
      clickOutside() {
         this.isDropshow = false;
      },
   },
}
</script>

<style lang="scss" scoped>
.select_box{
   width:100%;
   height:25px;
   position:relative;
   .select_box_input{
      width:100%;
      height:25px;
      position:relative;
      line-height:25px;
      .select_box_input_inner{
         width:100%;
         height:100%;
         padding:0 22px 0 10px;
         color:#FFF6D4;
         font-size:12px;
         font-family: PingFangSC-Medium, PingFang SC;
         font-weight:500;
         background: #d99649;
         border:1px solid #d99649;
         box-sizing: border-box;
         //  box-shadow: 0 -1px 0 0 #fff5d9;
        box-shadow: 0 1px 0 0 #FFF5D9,0 -1px 1px 0 rgba(0,0,0,0.5);
         border-radius:8px;
      }
      .icon_suffix{
         display: inline-block;
         width:10px;
         height:7px;
         background: url('../../assets/images/children-file/triangle.png') no-repeat;
         background-size:100% 100%;
         position:absolute;
         top:9px;
         right:7px;
         z-index:10;
         transform: rotate(0deg);
         transition:transform .3s;
         &.is_reverse{
            transform: rotate(180deg);
         }
      }
   }
   .select_box_dropdown{
      min-width:80px;
      height:90px;
      position: absolute;
      top:30px;
      left:2px;
      z-index:10;
      transition:height .3s;
      .select_box_dropdown_wraper{
         width:100%;
         height:100%;
         // height:90px;
         border-radius:8px;
         background: #fff;
         box-shadow: 0px 2px 4px 0px rgba(201,201,201,0.5);
         overflow: hidden;

         .select_box_dropdow_list{
            height:auto;
            // max-height:90px;
            // background: #fff;
            // box-shadow: 0px 2px 4px 0px rgba(201,201,201,0.5);
            border-radius:8px;
            overflow-y: scroll;
            padding:3px 0;
            .select_box_dropdow_item{
               width:auto;
               height:26px;
               line-height:26px;
               text-align:center;
               padding:0 8px;
               color:#666;
               font-size:14px;
               font-weight:400;
               font-family: PingFangSC-Regular, PingFang SC;
               &:not(:last-child){
                  margin-bottom:3px;
               }
               &.is_active{
                  background:#FF8340;
                  color:#fff;
               }
            }
         }
      }
   }
}
</style>
